import { FC, ReactNode, Children } from 'react';
import styles from './TopTemplate.module.css';
import CommonHeader from '../../Header/CommonHeader';
import CommonFooter from '../../Footer/CommonFooter';
import { Heading } from '../../Heading';

/**
 * マイページトップ、サービス利用状況トップ、料金・請求トップ、ポイントトップ、会員情報トップ向けのテンプレート
 * @param pageTitle ページタイトル
 * @param children コンテンツ
 */
export interface TopTemplateProps {
    children?: ReactNode;
}

const TopTemplate = (props: TopTemplateProps) => {

    return (
        <TopTemplatePresentation
            {...props}
        />
    );
};

const TopTemplatePresentation = ({children}: TopTemplateProps) => {
    const childrenArray = Children.toArray(children);
    const firstChild = childrenArray[0];
    const remainChild = childrenArray.slice(1);

    return (
        <>
            <CommonHeader />
            <div className={styles['str-column']}>
                <div className={styles['column-inner']}>
                    <main className={styles['main-column']}>
                        <div className={styles['str-outer']}>
                            <div className={styles['str-inner']}>
                                {/* <TopNavigation />
                                <TopUserBox /> */}
                                {/* <NoticeList align={NoticeListAlign.RIGHT} adjust={{mb: 8}}>
                                    <NoticeListItem text={'So-net Webサイトに記載の金額はすべて税込み金額です。'} />
                                </NoticeList> */}
                                {firstChild}
                            </div>
                        </div>
                        {remainChild}
                        {/* <TopSubContent /> */}
                    </main>
                </div>
            </div>
            <CommonFooter/>
        </>
    );
};

export const Partitionsection = (props: TopTemplateProps) => {
    return (
        <div className={styles['str-outer-partition']}>
            <div className={styles['str-inner']}>{props.children}</div>
        </div>
    );
};

export const LoadingBox: FC<{title?: string; id?: string; level?: 2 | 3 | 4 | 5 | 6}> = ({
    children,
    title,
    id,
    level = 2,
}) => {
    return (
        <>
            {title && <Heading level={level} text={title} id={id} />}
            {/* {children ?? <LoadingIcon />} */}
        </>
    );
};

export default TopTemplate;
